<ng-container *ngIf="canEdit">
    <p-inplace #content [preventClick]="true" (onActivate)="updateZones()">
        <ng-template pTemplate="display">
            <a (click)="content.activate()">{{currentZoneLabel}}</a>
        </ng-template>
        <ng-template pTemplate="content">
            <div class="p-d-flex p-ai-center p-jc-between p-mb-2">
                <label>Current Timezone - {{currentZoneLabel}}</label>
                <button pButton (click)="content.deactivate()" icon="pi pi-times"></button>
            </div>
            <div *ngIf="loadingZones" class="p-d-flex p-jc-center">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <ng-container *ngIf="!loadingZones">
                <p-panelMenu [model]="timezoneModel"></p-panelMenu>
            </ng-container>
        </ng-template>
    </p-inplace>
</ng-container>
<ng-container *ngIf="!canEdit">
    <span>{{currentZoneLabel}}</span>
</ng-container>
<p-dialog header="Changing Log Timezone"
          [modal]="true"
          [draggable]="false"
          [closable]="false"
          [(visible)]="showingDialog">
    <ng-template pTemplate="content">
        <ng-container *ngIf="confirmingZone">
            <div class="p-d-flex p-flex-column p-jc-center p-ai-center">
                <span class="p-mb-3">
                    Changing the timezone of {{log.name}} from <b>{{currentZoneLabel}}</b> to <b>{{formatLabel(confirmingZone.id)}} ({{confirmingZone.displayName}})</b>
                </span>
                <span>
                    <b>This timezone does {{confirmingZone.observesDaylightSavings ? ' ' : 'not '}}observe daylight savings</b>
                </span>
            </div>

        </ng-container>
    </ng-template>
    <ng-template pTemplate="footer">
        <ng-container *ngIf="confirmingZone">
            <button pButton class="p-button-secondary" [disabled]="updatingLog" label="Cancel" (click)="showingDialog = false" autofocus></button>
            <button pButton label="Confirm" [disabled]="updatingLog" [icon]="updatingLog ? 'pi pi-spin pi-spinner' : ''" (click)="updateTimezone()"></button>
        </ng-container>
        <ng-container *ngIf="!confirmingZone">
            <button pButton label="Close" (close)="showingDialog = false"></button>
        </ng-container>
    </ng-template>
</p-dialog>